export const AI_PRODUCT_SITES_PAGE_SIZE = 5;

export const AI_PRODUCT_RETURN_PATHS = {
  aiSites: '/ai-sites',
  aiStore: '/ai-store',
} as const;
